import MainLayout from '../components/MainLayout';
import PageHeader from '../components/PageHeader';
import OfflineScreen from '../components/OfflineScreen';
import { useFlowFormGlobal, FlowFormLeaveContext } from 't-lib-ui/structure';
import { useLocation } from 't-lib-ui/router';
import { sidebarLeaveHandler } from '../components/LeftSidebarFocus';
import { offlineSidebarSelection } from './offlineSelection';
import './OfflinePage.css';

// Shown in place of every /a page while the engine is offline (see AppRouter). The sidebar stays
// live, so the feed list is still browsable — picking anything lands back here until the
// connection returns, at which point the router swaps the real page back in.
const OfflinePage: React.FC = () => {
  useFlowFormGlobal('.flowForm.mainForm');
  const location = useLocation();

  return (
    <FlowFormLeaveContext.Provider value={sidebarLeaveHandler}>
      <MainLayout
        selectedFeed={offlineSidebarSelection(location.pathName)}
        right={({ onExpand }) => (
          <div className="offlinePage">
            <PageHeader title="Offline" onMenu={onExpand} />
            <OfflineScreen />
          </div>
        )}
      />
    </FlowFormLeaveContext.Provider>
  );
};

export default OfflinePage;
